module.exports = __webpack_public_path__ + "media/dashboard/assets/images/external/img_placeholder-f5e3d5fe14d6af1c9672bca373bb7cc7.jpg";